import React from "react";
import image1 from "assets/img/profile/ivy.jpg";
import image2 from "assets/img/profile/result.png";
import image3 from "assets/img/profile/personal.png";
import Card from "components/card";

const Project = () => {
  return (
    <Card extra={"w-full p-4 h-full"}>
      <div className="mb-0 w-full shadow-3xl shadow-shadow-500">
        <p className="mt-2 text-base text-gray-600 mb-2 dark:text-white">
          We believe every student has the potential to reach their academic peak. Our mission is to provide world-class educational support that builds confidence, competence, and a genuine love for learning.
        </p>
      </div>
      {/* Project 1 */}
      <div className="mt-4  flex w-full items-center justify-between rounded-2xl bg-white p-3 shadow-3xl shadow-shadow-500 dark:!bg-navy-700 dark:shadow-none">
        <div className="flex items-center">
          <div className="">
            <img className="h-[83px] w-[113px] rounded-lg rounded-2xl shadow-shadow-500" src={image1} alt="" />
          </div>
          <div className="ml-4">
            <p className="text-base font-medium text-navy-700 dark:text-white">
              Ivy League Tutors
            </p>
            <p className="mt-2 text-sm text-gray-600 dark:text-white">
              Learn from educators with degrees from top institutions who bring expertise and passion to every session.
            </p>
          </div>
        </div>
      </div>
      {/* Project 1 */}
      <div className="mt-3 flex w-full items-center justify-between rounded-2xl bg-white p-3 shadow-3xl shadow-shadow-500 dark:!bg-navy-700 dark:shadow-none">
        <div className="flex items-center">
          <div className="">
            <img className="h-[83px] w-[113px] rounded-lg rounded-2xl shadow-shadow-500" src={image2} alt="" />
          </div>
          <div className="ml-4">
            <p className="text-base font-medium text-navy-700 dark:text-white">
              Proven Results
            </p>
            <p className="mt-2 text-sm text-gray-600 dark:text-white">
              Our students consistently achieve higher grades, improved test scores, and greater academic confidence.
            </p>
          </div>
        </div>
      </div>
      {/* Project 1 */}
      <div className="mt-3 flex w-full items-center justify-between rounded-2xl bg-white p-3 shadow-3xl shadow-shadow-500 dark:!bg-navy-700 dark:shadow-none">
        <div className="flex items-center">
          <div className="">
            <img className="h-[73px] w-[123px] rounded-lg rounded-2xl shadow-shadow-500" src={image3} alt="" />
          </div>
          <div className="ml-4">
            <p className="text-base font-medium text-navy-700 dark:text-white">
              Personalized Approach
            </p>
            <p className="mt-2 text-sm text-gray-600 dark:text-white">
              Every student learns differently. We tailor our teaching methods to match individual learning styles and goals.
            </p>
          </div>
        </div>
       </div>
    </Card>
  );
};

export default Project;
